import React from 'react';
import { LabelField, ImageField } from '../../components/Admin';

class AreaModal extends React.Component {
	constructor(props){
		super(props);
		this.state = { items: [''], name: '', image: null, imageURL: void 0, edit: false };
		if (props.area){
			this.state = {
				name: props.area.name,
				items: JSON.parse(props.area.description || '[]'),
				imageURL: props.area.imageId,
				edit: true
			};
			this.validateInputs(this.state.items);
		}
	}

	onChangeItem = (ev, index) => {
		var { items } = this.state;
		items[index] = ev.target.value;
		this.validateInputs(items);
		this.setState({items});
	}

	validateInputs = items => {
		var found = items.filter(i => i.trim().length > 0).length;
		if (found === items.length)
			items.push('');
	}

	onSave = _ => {
		var { items, name, image, imageURL } = this.state;
		var area = { name, items: [...items], image, imageURL };
		area.items = area.items.filter(a => a.trim().length > 0);
		this.props.onSave(area);
	}

	render(){
		var { items, edit, name } = this.state;
		var { closeModal, onRemove } = this.props;
		return (
			<div className="wp-modal">
				<div className="modal-content">
					<div className="modal-header">
						<i onClick={closeModal} className="icon-close"></i>
					</div>
					<div className="modal-form">
						<div className="clearfix">
							<div className="left">
								<LabelField defaultValue={name} onChange={(_, value) => this.setState({name: value})} name="Nombre" rows={1} />
							</div>
							<div className="left">
								<ImageField onChange={(_, file, imageURL) => this.setState({image: file, imageURL})} name="Imagen" />
							</div>
						</div>
						<div className="label-field">
							<label>Información extra</label>
							<ul>
								{ items.map((item, k) => (
									<li key={`${k}`}>
										<input type="text" value={item} onChange={ev => this.onChangeItem(ev, k)} />
									</li>
								)) }
							</ul>
						</div>
					</div>
					<div className="modal-buttons">
						{edit && <button onClick={onRemove} className="delete"><i className="icon-remove"></i> Eliminar área</button>}
						<button onClick={this.onSave} className="save">Guardar</button>
					</div>
				</div>
			</div>
		)
	}
}

export default class Areas extends React.Component {
	state = { modalVisible: false, editItem: null, editIndex: -1 };
	closeModal = _ => {
		this.setState({modalVisible: false, editItem: null, editIndex: -1});
	}
	openModal = _ => this.setState({modalVisible: true, editItem: null, editIndex: -1});
	editArea = (area, index) => {
		this.setState({modalVisible: true, editItem: {...area}, editIndex: index})
	};
	addArea = area => {
		var { editItem, editIndex } = this.state;
		var { onChangeKey } = this.props;
		onChangeKey(({website, files}) => {
			var newArea = {
				websiteId: website.websiteId,
				name: area.name,
				description: JSON.stringify(area.items),
				imageId: area.imageURL
			};
			if (editItem && editIndex > -1){
				newArea.areaId = editItem.areaId;
				website.area[editIndex] = newArea;
			} else {
				website.area.push(newArea);
			}
			if (area.image){
				files[`area.${(editItem && editIndex > -1) ? editIndex : website.area.length-1}`] = area.image;
			}
			return { website, files };
		});
		this.setState({modalVisible: false, editItem: null, editIndex: -1}, _ => {
			document.querySelectorAll('.section__area .in_view_animate:not(.scrolled)').forEach(el => {
				el.classList.add('scrolled');
			});
		});
	};

	onRemove = _ => {
		var { editIndex, editItem } = this.state;
		var { onChangeKey } = this.props;
		if (editItem && editIndex > -1){
			onChangeKey(({website, files}) => {
				website.area.splice(editIndex, 1);
				delete files[`area.${editIndex}`];
				return { website, files };
			});
		}
		this.setState({modalVisible: false, editItem: null, editIndex: -1});
	}

	render(){
		var { modalVisible, editItem } = this.state;
		var { website, onChangeProp } = this.props;
		return (
			<div>
				<LabelField defaultValue={website.areaTitle} onChange={onChangeProp} prop="areaTitle" name="Título" info="40 caracteres" rows={1} />
				<div className="label-field item-list">
					<label>Áreas</label>
					{website.area.map((a, k) => (
						<div onClick={_ => this.editArea(a, k)} className="item" key={`${k}${a.name}`}>
							{a.name}
							<i className="icon-edit"></i>
						</div>
					))}
				</div>
				<div onClick={this.openModal} className="add-item">
					Nueva Área
				</div>
				{ modalVisible && <AreaModal onRemove={this.onRemove} area={editItem} onSave={this.addArea} closeModal={this.closeModal} /> }
			</div>
		)
	}
}
